export enum StringLatinGroup {
    ERLAUBTEZEICHEN,
    ERLAUBTE_LEERZEICHEN,
}

export const newCharacters: string[] = [
    '\u0009', // <TAB>
    '\n',     // <LF>
    '\r',     // <CR>
];

export const allCharacters = [
    '"', // "
    '\u0020', // <SPACE>
    '\u0021', // !
    '\u0023', // #
    '\u0024', // $
    '\u0025', // %
    '\u0026', // &
    '\u0027', // '
    '\u0028', // (
    '\u0029', // )
    '\u002A', // *
    '\u002B', // +
    '\u002C', // ,
    '\u002D', // -
    '\u002E', // .
    '\u002F', // /
    '\u0030', // 0
    '\u0031', // 1
    '\u0032', // 2
    '\u0033', // 3
    '\u0034', // 4
    '\u0035', // 5
    '\u0036', // 6
    '\u0037', // 7
    '\u0038', // 8
    '\u0039', // 9
    '\u003A', // :
    '\u003B', // ;
    '\u003C', // <
    '\u003D', // =
    '\u003E', // >
    '\u003F', // ?
    '\u0040', // @
    '\u0041', // A
    '\u0041\u030B', // A̋
    '\u0042', // B
    '\u0043', // C
    '\u0043\u0300', // C̀
    '\u0043\u0304', // C̄
    '\u0043\u0306', // C̆
    '\u0043\u0308', // C̈
    '\u0043\u0315', // C̕
    '\u0043\u0323', // C̣
    '\u0043\u0326', // C̦
    '\u0043\u0328\u0306', // C̨̆
    '\u0044', // D
    '\u0044\u0302', // D̂
    '\u0045', // E
    '\u0046', // F
    '\u0046\u0300', // F̀
    '\u0046\u0304', // F̄
    '\u0047', // G
    '\u0047\u0300', // G̀
    '\u0048', // H
    '\u0048\u0304', // H̄
    '\u0048\u0326', // H̦
    '\u0048\u0331', // H̱
    '\u0049', // I
    '\u004A', // J
    '\u004A\u0301', // J́
    '\u004A\u030C', // J̌
    '\u004B', // K
    '\u004B\u0300', // K̀
    '\u004B\u0302', // K̂
    '\u004B\u0304', // K̄
    '\u004B\u0307', // K̇
    '\u004B\u0315', // K̕
    '\u004B\u031B', // K̛
    '\u004B\u0326', // K̦
    '\u004B\u035F\u0048', // K͟H
    '\u004B\u035F\u0068', // K͟h
    '\u004C', // L
    '\u004C\u0302', // L̂
    '\u004C\u0325', // L̥
    '\u004C\u0325\u0304', // L̥̄
    '\u004C\u0326', // L̦
    '\u004D', // M
    '\u004D\u0300', // M̀
    '\u004D\u0302', // M̂
    '\u004D\u0306', // M̆
    '\u004D\u0310', // M̐
    '\u004E', // N
    '\u004E\u0302', // N̂
    '\u004E\u0304', // N̄
    '\u004E\u0306', // N̆
    '\u004E\u0326', // N̦
    '\u004F', // O
    '\u0050', // P
    '\u0050\u0300', // P̀
    '\u0050\u0304', // P̄
    '\u0050\u0315', // P̕
    '\u0050\u0323', // P̣
    '\u0051', // Q
    '\u0052', // R
    '\u0052\u0306', // R̆
    '\u0052\u0325', // R̥
    '\u0052\u0325\u0304', // R̥̄
    '\u0053', // S
    '\u0053\u0300', // S̀
    '\u0053\u0304', // S̄
    '\u0053\u031B\u0304', // S̛̄
    '\u0053\u0331', // S̱
    '\u0054', // T
    '\u0054\u0300', // T̀
    '\u0054\u0304', // T̄
    '\u0054\u0308', // T̈
    '\u0054\u0315', // T̕
    '\u0054\u031B', // T̛
    '\u0055', // U
    '\u0055\u0307', // U̇
    '\u0056', // V
    '\u0057', // W
    '\u0058', // X
    '\u0059', // Y
    '\u005A', // Z
    '\u005A\u0300', // Z̀
    '\u005A\u0304', // Z̄
    '\u005A\u0306', // Z̆
    '\u005A\u0308', // Z̈
    '\u005A\u0327', // Z̧
    '\u005B', // [
    '\\', // \
    '\u005D', // ]
    '\u005E', // ^
    '\u005F', // _
    '\u0060', // `
    '\u0061', // a
    '\u0061\u030B', // a̋
    '\u0062', // b
    '\u0063', // c
    '\u0063\u0300', // c̀
    '\u0063\u0304', // c̄
    '\u0063\u0306', // c̆
    '\u0063\u0308', // c̈
    '\u0063\u0315', // c̕
    '\u0063\u0323', // c̣
    '\u0063\u0326', // c̦
    '\u0063\u0328\u0306', // c̨̆
    '\u0064', // d
    '\u0064\u0302', // d̂
    '\u0065', // e
    '\u0066', // f
    '\u0066\u0300', // f̀
    '\u0066\u0304', // f̄
    '\u0067', // g
    '\u0067\u0300', // g̀
    '\u0068', // h
    '\u0068\u0304', // h̄
    '\u0068\u0326', // h̦
    '\u0069', // i
    '\u006A', // j
    '\u006A\u0301', // j́
    '\u006B', // k
    '\u006B\u0300', // k̀
    '\u006B\u0302', // k̂
    '\u006B\u0304', // k̄
    '\u006B\u0307', // k̇
    '\u006B\u0315', // k̕
    '\u006B\u031B', // k̛
    '\u006B\u0326', // k̦
    '\u006B\u035F\u0068', // k͟h
    '\u006C', // l
    '\u006C\u0302', // l̂
    '\u006C\u0325', // l̥
    '\u006C\u0325\u0304', // l̥̄
    '\u006C\u0326', // l̦
    '\u006D', // m
    '\u006D\u0300', // m̀
    '\u006D\u0302', // m̂
    '\u006D\u0306', // m̆
    '\u006D\u0310', // m̐
    '\u006E', // n
    '\u006E\u0302', // n̂
    '\u006E\u0304', // n̄
    '\u006E\u0306', // n̆
    '\u006E\u0326', // n̦
    '\u006F', // o
    '\u0070', // p
    '\u0070\u0300', // p̀
    '\u0070\u0304', // p̄
    '\u0070\u0315', // p̕
    '\u0070\u0323', // p̣
    '\u0071', // q
    '\u0072', // r
    '\u0072\u0306', // r̆
    '\u0072\u0325', // r̥
    '\u0072\u0325\u0304', // r̥̄
    '\u0073', // s
    '\u0073\u0300', // s̀
    '\u0073\u0304', // s̄
    '\u0073\u031B\u0304', // s̛̄
    '\u0073\u0331', // s̱
    '\u0074', // t
    '\u0074\u0300', // t̀
    '\u0074\u0304', // t̄
    '\u0074\u0315', // t̕
    '\u0074\u031B', // t̛
    '\u0075', // u
    '\u0075\u0307', // u̇
    '\u0076', // v
    '\u0077', // w
    '\u0078', // x
    '\u0079', // y
    '\u007A', // z
    '\u007A\u0300', // z̀
    '\u007A\u0304', // z̄
    '\u007A\u0306', // z̆
    '\u007A\u0308', // z̈
    '\u007A\u0327', // z̧
    '\u007B', // {
    '\u007C', // |
    '\u007D', // }
    '\u007E', // ~
    '\u00A0', // &nbsp;
    '\u00A1', // ¡
    '\u00A2', // ¢
    '\u00A3', // £
    '\u00A4', // ¤
    '\u00A5', // ¥
    '\u00A6', // ¦
    '\u00A7', // §
    '\u00A8', // ¨
    '\u00A9', // ©
    '\u00AA', // ª
    '\u00AB', // «
    '\u00AC', // ¬
    '\u00AE', // ®
    '\u00AF', // ¯
    '\u00B0', // °
    '\u00B1', // ±
    '\u00B2', // ²
    '\u00B3', // ³
    '\u00B4', // ´
    '\u00B5', // µ
    '\u00B6', // ¶
    '\u00B7', // ·
    '\u00B8', // ¸
    '\u00B9', // ¹
    '\u00BA', // º
    '\u00BB', // »
    '\u00BC', // ¼
    '\u00BD', // ½
    '\u00BE', // ¾
    '\u00BF', // ¿
    '\u00C0', // À
    '\u00C1', // Á
    '\u00C2', // Â
    '\u00C3', // Ã
    '\u00C4', // Ä
    '\u00C5', // Å
    '\u00C6', // Æ
    '\u00C7', // Ç
    '\u00C7\u0306', // Ç̆
    '\u00C8', // È
    '\u00C9', // É
    '\u00CA', // Ê
    '\u00CB', // Ë
    '\u00CC', // Ì
    '\u00CD', // Í
    '\u00CE', // Î
    '\u00CF', // Ï
    '\u00D0', // Ð
    '\u00D1', // Ñ
    '\u00D2', // Ò
    '\u00D3', // Ó
    '\u00D4', // Ô
    '\u00D5', // Õ
    '\u00D6', // Ö
    '\u00D7', // ×
    '\u00D8', // Ø
    '\u00D9', // Ù
    '\u00DA', // Ú
    '\u00DB', // Û
    '\u00DB\u0304', // Û̄
    '\u00DC', // Ü
    '\u00DD', // Ý
    '\u00DE', // Þ
    '\u00DF', // ß
    '\u00E0', // à
    '\u00E1', // á
    '\u00E2', // â
    '\u00E3', // ã
    '\u00E4', // ä
    '\u00E5', // å
    '\u00E6', // æ
    '\u00E7', // ç
    '\u00E7\u0306', // ç̆
    '\u00E8', // è
    '\u00E9', // é
    '\u00EA', // ê
    '\u00EB', // ë
    '\u00EC', // ì
    '\u00ED', // í
    '\u00EE', // î
    '\u00EF', // ï
    '\u00F0', // ð
    '\u00F1', // ñ
    '\u00F2', // ò
    '\u00F3', // ó
    '\u00F4', // ô
    '\u00F5', // õ
    '\u00F6', // ö
    '\u00F7', // ÷
    '\u00F8', // ø
    '\u00F9', // ù
    '\u00FA', // ú
    '\u00FB', // û
    '\u00FB\u0304', // û̄
    '\u00FC', // ü
    '\u00FD', // ý
    '\u00FE', // þ
    '\u00FF', // ÿ
    '\u00FF\u0301', // ÿ́
    '\u0100', // Ā
    '\u0101', // ā
    '\u0102', // Ă
    '\u0103', // ă
    '\u0104', // Ą
    '\u0105', // ą
    '\u0106', // Ć
    '\u0107', // ć
    '\u0108', // Ĉ
    '\u0109', // ĉ
    '\u010A', // Ċ
    '\u010B', // ċ
    '\u010C', // Č
    '\u010C\u0315', // Č̕
    '\u010C\u0323', // Č̣
    '\u010D', // č
    '\u010D\u0315', // č̕
    '\u010D\u0323', // č̣
    '\u010E', // Ď
    '\u010F', // ď
    '\u0110', // Đ
    '\u0111', // đ
    '\u0112', // Ē
    '\u0113', // ē
    '\u0113\u030D', // ē̍
    '\u0114', // Ĕ
    '\u0115', // ĕ
    '\u0116', // Ė
    '\u0117', // ė
    '\u0118', // Ę
    '\u0119', // ę
    '\u011A', // Ě
    '\u011B', // ě
    '\u011C', // Ĝ
    '\u011D', // ĝ
    '\u011E', // Ğ
    '\u011F', // ğ
    '\u0120', // Ġ
    '\u0121', // ġ
    '\u0122', // Ģ
    '\u0123', // ģ
    '\u0124', // Ĥ
    '\u0125', // ĥ
    '\u0126', // Ħ
    '\u0127', // ħ
    '\u0128', // Ĩ
    '\u0129', // ĩ
    '\u012A', // Ī
    '\u012A\u0301', // Ī́
    '\u012B', // ī
    '\u012B\u0301', // ī́
    '\u012C', // Ĭ
    '\u012D', // ĭ
    '\u012E', // Į
    '\u012F', // į
    '\u0130', // İ
    '\u0131', // ı
    '\u0132', // Ĳ
    '\u0133', // ĳ
    '\u0134', // Ĵ
    '\u0135', // ĵ
    '\u0136', // Ķ
    '\u0137', // ķ
    '\u0138', // ĸ
    '\u0139', // Ĺ
    '\u013A', // ĺ
    '\u013B', // Ļ
    '\u013C', // ļ
    '\u013D', // Ľ
    '\u013E', // ľ
    '\u013F', // Ŀ
    '\u0140', // ŀ
    '\u0141', // Ł
    '\u0142', // ł
    '\u0143', // Ń
    '\u0144', // ń
    '\u0145', // Ņ
    '\u0146', // ņ
    '\u0147', // Ň
    '\u0148', // ň
    '\u0149', // ŉ
    '\u014A', // Ŋ
    '\u014B', // ŋ
    '\u014C', // Ō
    '\u014D', // ō
    '\u014D\u030D', // ō̍
    '\u014E', // Ŏ
    '\u014F', // ŏ
    '\u0150', // Ő
    '\u0151', // ő
    '\u0152', // Œ
    '\u0153', // œ
    '\u0154', // Ŕ
    '\u0155', // ŕ
    '\u0156', // Ŗ
    '\u0157', // ŗ
    '\u0158', // Ř
    '\u0159', // ř
    '\u015A', // Ś
    '\u015B', // ś
    '\u015C', // Ŝ
    '\u015D', // ŝ
    '\u015E', // Ş
    '\u015F', // ş
    '\u0160', // Š
    '\u0161', // š
    '\u0162', // Ţ
    '\u0163', // ţ
    '\u0164', // Ť
    '\u0165', // ť
    '\u0166', // Ŧ
    '\u0167', // ŧ
    '\u0168', // Ũ
    '\u0169', // ũ
    '\u016A', // Ū
    '\u016B', // ū
    '\u016C', // Ŭ
    '\u016D', // ŭ
    '\u016E', // Ů
    '\u016F', // ů
    '\u0170', // Ű
    '\u0171', // ű
    '\u0172', // Ų
    '\u0173', // ų
    '\u0174', // Ŵ
    '\u0175', // ŵ
    '\u0176', // Ŷ
    '\u0177', // ŷ
    '\u0178', // Ÿ
    '\u0179', // Ź
    '\u017A', // ź
    '\u017B', // Ż
    '\u017C', // ż
    '\u017D', // Ž
    '\u017D\u0326', // Ž̦
    '\u017D\u0327', // Ž̧
    '\u017E', // ž
    '\u017E\u0326', // ž̦
    '\u017E\u0327', // ž̧
    '\u0187', // Ƈ
    '\u0188', // ƈ
    '\u018F', // Ə
    '\u0192', // ƒ
    '\u0197', // Ɨ
    '\u01A0', // Ơ
    '\u01A1', // ơ
    '\u01AF', // Ư
    '\u01B0', // ư
    '\u01B7', // Ʒ
    '\u01CD', // Ǎ
    '\u01CE', // ǎ
    '\u01CF', // Ǐ
    '\u01D0', // ǐ
    '\u01D1', // Ǒ
    '\u01D2', // ǒ
    '\u01D3', // Ǔ
    '\u01D4', // ǔ
    '\u01D5', // Ǖ
    '\u01D6', // ǖ
    '\u01D7', // Ǘ
    '\u01D8', // ǘ
    '\u01D9', // Ǚ
    '\u01DA', // ǚ
    '\u01DB', // Ǜ
    '\u01DC', // ǜ
    '\u01DE', // Ǟ
    '\u01DF', // ǟ
    '\u01E2', // Ǣ
    '\u01E3', // ǣ
    '\u01E4', // Ǥ
    '\u01E5', // ǥ
    '\u01E6', // Ǧ
    '\u01E7', // ǧ
    '\u01E8', // Ǩ
    '\u01E9', // ǩ
    '\u01EA', // Ǫ
    '\u01EB', // ǫ
    '\u01EC', // Ǭ
    '\u01ED', // ǭ
    '\u01EE', // Ǯ
    '\u01EF', // ǯ
    '\u01F0', // ǰ
    '\u01F4', // Ǵ
    '\u01F5', // ǵ
    '\u01F8', // Ǹ
    '\u01F9', // ǹ
    '\u01FA', // Ǻ
    '\u01FB', // ǻ
    '\u01FC', // Ǽ
    '\u01FD', // ǽ
    '\u01FE', // Ǿ
    '\u01FF', // ǿ
    '\u0212', // Ȓ
    '\u0213', // ȓ
    '\u0218', // Ș
    '\u0219', // ș
    '\u021A', // Ț
    '\u021B', // ț
    '\u021E', // Ȟ
    '\u021F', // ȟ
    '\u0227', // ȧ
    '\u0228', // Ȩ
    '\u0229', // ȩ
    '\u022A', // Ȫ
    '\u022B', // ȫ
    '\u022C', // Ȭ
    '\u022D', // ȭ
    '\u022E', // Ȯ
    '\u022F', // ȯ
    '\u0230', // Ȱ
    '\u0231', // ȱ
    '\u0232', // Ȳ
    '\u0233', // ȳ
    '\u0259', // ə
    '\u0268', // ɨ
    '\u0292', // ʒ
    '\u02B0', // ʰ
    '\u02B3', // ʳ
    '\u02B9', // ʹ
    '\u02BA', // ʺ
    '\u02BE', // ʾ
    '\u02BF', // ʿ
    '\u02C6', // ˆ
    '\u02C8', // ˈ
    '\u02CC', // ˌ
    '\u02DC', // ˜
    '\u02E2', // ˢ
    '\u0300', // ̀
    '\u0301', // ́
    '\u0302', // ̂
    '\u0304', // ̄
    '\u0306', // ̆
    '\u0307', // ̇
    '\u0308', // ̈
    '\u030B', // ̋
    '\u030C', // ̌
    '\u030D', // ̍
    '\u0310', // ̐
    '\u0315', // ̕
    '\u031B', // ̛
    '\u0323', // ̣
    '\u0325', // ̥
    '\u0326', // ̦
    '\u0327', // ̧
    '\u0328', // ̨
    '\u0331', // ̱
    '\u035F', // ͟
    '\u0386', // Ά
    '\u0388', // Έ
    '\u0389', // Ή
    '\u038A', // Ί
    '\u038C', // Ό
    '\u038E', // Ύ
    '\u038F', // Ώ
    '\u0390', // ΐ
    '\u0391', // Α
    '\u0392', // Β
    '\u0393', // Γ
    '\u0394', // Δ
    '\u0395', // Ε
    '\u0396', // Ζ
    '\u0397', // Η
    '\u0398', // Θ
    '\u0399', // Ι
    '\u039A', // Κ
    '\u039B', // Λ
    '\u039C', // Μ
    '\u039D', // Ν
    '\u039E', // Ξ
    '\u039F', // Ο
    '\u03A0', // Π
    '\u03A1', // Ρ
    '\u03A3', // Σ
    '\u03A4', // Τ
    '\u03A5', // Υ
    '\u03A6', // Φ
    '\u03A7', // Χ
    '\u03A8', // Ψ
    '\u03A9', // Ω
    '\u03AA', // Ϊ
    '\u03AB', // Ϋ
    '\u03AC', // ά
    '\u03AD', // έ
    '\u03AE', // ή
    '\u03AF', // ί
    '\u03B0', // ΰ
    '\u03B1', // α
    '\u03B2', // β
    '\u03B3', // γ
    '\u03B4', // δ
    '\u03B5', // ε
    '\u03B6', // ζ
    '\u03B7', // η
    '\u03B8', // θ
    '\u03B9', // ι
    '\u03BA', // κ
    '\u03BB', // λ
    '\u03BC', // μ
    '\u03BD', // ν
    '\u03BE', // ξ
    '\u03BF', // ο
    '\u03C0', // π
    '\u03C1', // ρ
    '\u03C2', // ς
    '\u03C3', // σ
    '\u03C4', // τ
    '\u03C5', // υ
    '\u03C6', // φ
    '\u03C7', // χ
    '\u03C8', // ψ
    '\u03C9', // ω
    '\u03CA', // ϊ
    '\u03CB', // ϋ
    '\u03CC', // ό
    '\u03CD', // ύ
    '\u03CE', // ώ
    '\u040D', // Ѝ
    '\u0410', // А
    '\u0411', // Б
    '\u0412', // В
    '\u0413', // Г
    '\u0414', // Д
    '\u0415', // Е
    '\u0416', // Ж
    '\u0417', // З
    '\u0418', // И
    '\u0419', // Й
    '\u041A', // К
    '\u041B', // Л
    '\u041C', // М
    '\u041D', // Н
    '\u041E', // О
    '\u041F', // П
    '\u0420', // Р
    '\u0421', // С
    '\u0422', // Т
    '\u0423', // У
    '\u0424', // Ф
    '\u0425', // Х
    '\u0426', // Ц
    '\u0427', // Ч
    '\u0428', // Ш
    '\u0429', // Щ
    '\u042A', // Ъ
    '\u042C', // Ь
    '\u042E', // Ю
    '\u042F', // Я
    '\u0430', // а
    '\u0431', // б
    '\u0432', // в
    '\u0433', // г
    '\u0434', // д
    '\u0435', // е
    '\u0436', // ж
    '\u0437', // з
    '\u0438', // и
    '\u0439', // й
    '\u043A', // к
    '\u043B', // л
    '\u043C', // м
    '\u043D', // н
    '\u043E', // о
    '\u043F', // п
    '\u0440', // р
    '\u0441', // с
    '\u0442', // т
    '\u0443', // у
    '\u0444', // ф
    '\u0445', // х
    '\u0446', // ц
    '\u0447', // ч
    '\u0448', // ш
    '\u0449', // щ
    '\u044A', // ъ
    '\u044C', // ь
    '\u044E', // ю
    '\u044F', // я
    '\u045D', // ѝ
    '\u1D48', // ᵈ
    '\u1D57', // ᵗ
    '\u1E02', // Ḃ
    '\u1E03', // ḃ
    '\u1E06', // Ḇ
    '\u1E07', // ḇ
    '\u1E0A', // Ḋ
    '\u1E0B', // ḋ
    '\u1E0C', // Ḍ
    '\u1E0D', // ḍ
    '\u1E0E', // Ḏ
    '\u1E0F', // ḏ
    '\u1E10', // Ḑ
    '\u1E11', // ḑ
    '\u1E17', // ḗ
    '\u1E1C', // Ḝ
    '\u1E1D', // ḝ
    '\u1E1E', // Ḟ
    '\u1E1F', // ḟ
    '\u1E20', // Ḡ
    '\u1E21', // ḡ
    '\u1E22', // Ḣ
    '\u1E23', // ḣ
    '\u1E24', // Ḥ
    '\u1E25', // ḥ
    '\u1E26', // Ḧ
    '\u1E27', // ḧ
    '\u1E28', // Ḩ
    '\u1E29', // ḩ
    '\u1E2A', // Ḫ
    '\u1E2B', // ḫ
    '\u1E2F', // ḯ
    '\u1E30', // Ḱ
    '\u1E31', // ḱ
    '\u1E32', // Ḳ
    '\u1E32\u0304', // Ḳ̄
    '\u1E33', // ḳ
    '\u1E33\u0304', // ḳ̄
    '\u1E34', // Ḵ
    '\u1E35', // ḵ
    '\u1E36', // Ḷ
    '\u1E37', // ḷ
    '\u1E3A', // Ḻ
    '\u1E3B', // ḻ
    '\u1E40', // Ṁ
    '\u1E41', // ṁ
    '\u1E42', // Ṃ
    '\u1E43', // ṃ
    '\u1E44', // Ṅ
    '\u1E45', // ṅ
    '\u1E46', // Ṇ
    '\u1E47', // ṇ
    '\u1E48', // Ṉ
    '\u1E49', // ṉ
    '\u1E52', // Ṓ
    '\u1E53', // ṓ
    '\u1E54', // Ṕ
    '\u1E55', // ṕ
    '\u1E56', // Ṗ
    '\u1E57', // ṗ
    '\u1E58', // Ṙ
    '\u1E59', // ṙ
    '\u1E5A', // Ṛ
    '\u1E5B', // ṛ
    '\u1E5E', // Ṟ
    '\u1E5F', // ṟ
    '\u1E60', // Ṡ
    '\u1E61', // ṡ
    '\u1E62', // Ṣ
    '\u1E62\u0304', // Ṣ̄
    '\u1E63', // ṣ
    '\u1E63\u0304', // ṣ̄
    '\u1E6A', // Ṫ
    '\u1E6B', // ṫ
    '\u1E6C', // Ṭ
    '\u1E6C\u0304', // Ṭ̄
    '\u1E6D', // ṭ
    '\u1E6D\u0304', // ṭ̄
    '\u1E6E', // Ṯ
    '\u1E6F', // ṯ
    '\u1E80', // Ẁ
    '\u1E81', // ẁ
    '\u1E82', // Ẃ
    '\u1E83', // ẃ
    '\u1E84', // Ẅ
    '\u1E85', // ẅ
    '\u1E86', // Ẇ
    '\u1E87', // ẇ
    '\u1E8C', // Ẍ
    '\u1E8D', // ẍ
    '\u1E8E', // Ẏ
    '\u1E8F', // ẏ
    '\u1E90', // Ẑ
    '\u1E91', // ẑ
    '\u1E92', // Ẓ
    '\u1E93', // ẓ
    '\u1E94', // Ẕ
    '\u1E95', // ẕ
    '\u1E96', // ẖ
    '\u1E97', // ẗ
    '\u1E9E', // ẞ
    '\u1EA0', // Ạ
    '\u1EA0\u0308', // Ạ̈
    '\u1EA1', // ạ
    '\u1EA1\u0308', // ạ̈
    '\u1EA2', // Ả
    '\u1EA3', // ả
    '\u1EA4', // Ấ
    '\u1EA5', // ấ
    '\u1EA6', // Ầ
    '\u1EA7', // ầ
    '\u1EA8', // Ẩ
    '\u1EA9', // ẩ
    '\u1EAA', // Ẫ
    '\u1EAB', // ẫ
    '\u1EAC', // Ậ
    '\u1EAD', // ậ
    '\u1EAE', // Ắ
    '\u1EAF', // ắ
    '\u1EB0', // Ằ
    '\u1EB1', // ằ
    '\u1EB2', // Ẳ
    '\u1EB3', // ẳ
    '\u1EB4', // Ẵ
    '\u1EB5', // ẵ
    '\u1EB6', // Ặ
    '\u1EB7', // ặ
    '\u1EB8', // Ẹ
    '\u1EB9', // ẹ
    '\u1EBA', // Ẻ
    '\u1EBB', // ẻ
    '\u1EBC', // Ẽ
    '\u1EBD', // ẽ
    '\u1EBE', // Ế
    '\u1EBF', // ế
    '\u1EC0', // Ề
    '\u1EC1', // ề
    '\u1EC2', // Ể
    '\u1EC3', // ể
    '\u1EC4', // Ễ
    '\u1EC5', // ễ
    '\u1EC6', // Ệ
    '\u1EC7', // ệ
    '\u1EC8', // Ỉ
    '\u1EC9', // ỉ
    '\u1ECA', // Ị
    '\u1ECB', // ị
    '\u1ECC', // Ọ
    '\u1ECC\u0308', // Ọ̈
    '\u1ECD', // ọ
    '\u1ECD\u0308', // ọ̈
    '\u1ECE', // Ỏ
    '\u1ECF', // ỏ
    '\u1ED0', // Ố
    '\u1ED1', // ố
    '\u1ED2', // Ồ
    '\u1ED3', // ồ
    '\u1ED4', // Ổ
    '\u1ED5', // ổ
    '\u1ED6', // Ỗ
    '\u1ED7', // ỗ
    '\u1ED8', // Ộ
    '\u1ED9', // ộ
    '\u1EDA', // Ớ
    '\u1EDB', // ớ
    '\u1EDC', // Ờ
    '\u1EDD', // ờ
    '\u1EDE', // Ở
    '\u1EDF', // ở
    '\u1EE0', // Ỡ
    '\u1EE1', // ỡ
    '\u1EE2', // Ợ
    '\u1EE3', // ợ
    '\u1EE4', // Ụ
    '\u1EE4\u0304', // Ụ̄
    '\u1EE4\u0308', // Ụ̈
    '\u1EE5', // ụ
    '\u1EE5\u0304', // ụ̄
    '\u1EE5\u0308', // ụ̈
    '\u1EE6', // Ủ
    '\u1EE7', // ủ
    '\u1EE8', // Ứ
    '\u1EE9', // ứ
    '\u1EEA', // Ừ
    '\u1EEB', // ừ
    '\u1EEC', // Ử
    '\u1EED', // ử
    '\u1EEE', // Ữ
    '\u1EEF', // ữ
    '\u1EF0', // Ự
    '\u1EF1', // ự
    '\u1EF2', // Ỳ
    '\u1EF3', // ỳ
    '\u1EF4', // Ỵ
    '\u1EF5', // ỵ
    '\u1EF6', // Ỷ
    '\u1EF7', // ỷ
    '\u1EF8', // Ỹ
    '\u1EF9', // ỹ
    '\u2018', // ‘
    '\u2019', // ’
    '\u201A', // ‚
    '\u201C', // “
    '\u201D', // ”
    '\u201E', // „
    '\u2020', // †
    '\u2021', // ‡
    '\u2026', // …
    '\u2030', // ‰
    '\u2032', // ′
    '\u2033', // ″
    '\u2039', // ‹
    '\u203A', // ›
    '\u2070', // ⁰
    '\u2074', // ⁴
    '\u2075', // ⁵
    '\u2076', // ⁶
    '\u2077', // ⁷
    '\u2078', // ⁸
    '\u2079', // ⁹
    '\u207F', // ⁿ
    '\u2080', // ₀
    '\u2081', // ₁
    '\u2082', // ₂
    '\u2083', // ₃
    '\u2084', // ₄
    '\u2085', // ₅
    '\u2086', // ₆
    '\u2087', // ₇
    '\u2088', // ₈
    '\u2089', // ₉
    '\u20AC', // €
    '\u2122', // ™
    '\u221E', // ∞
    '\u2264', // ≤
    '\u2265', // ≥
    'K͟', //
    'k͟',
    'C̨',
];

// Map für schnellen Lookup
export const allowedCharactersMap: Map<StringLatinGroup, Set<string>> = new Map([
    [StringLatinGroup.ERLAUBTEZEICHEN, new Set(allCharacters)],
    [StringLatinGroup.ERLAUBTE_LEERZEICHEN, new Set(newCharacters)],
]);
